import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMedal } from "@fortawesome/free-solid-svg-icons";

const GrupoPropuestas = ({ municipioId, munUrl, estado, tituloGrupo }) => {
  const [propuestas, guardarPropuestas] = useState([]);
  const [error, guardarError] = useState(false);

  useEffect(() => {
    const obtenerPropuestas = () => {
      axios
        .get(`/api/propuestas?municipioId=${municipioId}&estado=${estado}`)
        .then((respuesta) => {
          //Colocar en el state
          guardarPropuestas(respuesta.data.propuestas);
        })
        .catch((error) => guardarError(true));
    };
    obtenerPropuestas();
    return () => {
      guardarPropuestas([]);
    };
  }, [estado, municipioId]);

  if (!municipioId || propuestas.length === 0 || error) {
    return null;
  }
  return (
    <Fragment>
      <div className="row px-3 mb-4">
        <div className="col-md-12 m-2 ppr-titulo centrado">
          <h3 className="my-auto">{tituloGrupo}</h3>
        </div>
      </div>

      <div className="row">
        {propuestas.map((propuesta) => (
          <div className="col-md-4 card-deck mx-auto" key={propuesta._id}>
            <div className="card mb-3">
              <img
                className="thumbnail ppr-img-thumbnail position-relative"
                src={`/api/public/${propuesta.img}`}
                alt={propuesta.titulo}
              />
              {propuesta.estado === "seleccionada" && (
                <div className="overlay">
                  <FontAwesomeIcon icon={faMedal} size="2x" />
                </div>
              )}

              <div className="card-body">
                {propuesta.eje && (
                  <span className="badge badge-primary tag">
                    {propuesta.eje}
                  </span>
                )}

                <h3 className="card-title centrado">{propuesta.titulo}</h3>
                <h6>PRESUPUESTO: ${propuesta.presupuesto}</h6>
                <p className="card-text">{propuesta.subtitulo}</p>
                {propuesta.estado === "seleccionada" && (
                  <p style={{ color: "#0a4797" }}>
                    <b>ESTADO DE EJECUCIÓN:</b> {propuesta.ejecucion}
                  </p>
                )}
              </div>
              <div className="card-footer">
                <center>
                  <Link
                    to={`/municipio/${munUrl}/propuesta/${propuesta._id}`}
                    key={propuesta._id}
                    className="btn ppr-btn-verde font-weight-bold"
                  >
                    MÁS INFORMACIÓN
                  </Link>
                </center>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Fragment>
  );
};

export default GrupoPropuestas;
